export const fieldUser = [
    {
        id:"buildingId",
        name:"buildingId", 
        label:"Building Id",
        placeHolder: "Building Id",
        type:"select",
        errorMessage: "Building Id",
    },
    {
        id:"customerName",
        name:"customerName", 
        label:"Customer Name & ID",
        type:"input",
        inputType:"text",
        disabled: true,
    },
    {
        id:"floor",
        name:"floor", 
        label:"Floor Name",
        type:"input",
        inputType:"text",
    },
    {
        id:"floorPlan",
        name:"floorPlan", 
        label:"Floor Plan",
        type:"attach",
        inputType:"attachment",
    },
]
